// 移动端适配方案
export function setRem() {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDOM = document.documentElement

  // 限制最大和最小宽度
  const maxWidth = 375
  const minWidth = 320

  let width = htmlWidth
  if (width > maxWidth) width = maxWidth
  if (width < minWidth) width = minWidth

  // 设计稿宽度为 375px，根字体大小为 37.5px
  const fontSize = (width / 375) * 37.5
  htmlDOM.style.fontSize = fontSize + 'px'
}

// 初始化
setRem()

// 监听窗口变化
window.addEventListener('resize', setRem)

// 监听页面显示（解决某些浏览器的兼容性问题）
document.addEventListener('DOMContentLoaded', setRem)
window.addEventListener('pageshow', setRem)
